<template>
  <header class="header">
    <div class="header-content">
      <div class="logo" @click="redeemClicked">
        <img src="@/assets/images/logo_header.png" alt="Logo Click and Plan" />
      </div>

      <div class="header_icons_container">
        <!-- Reservas -->
        <button 
          type="button"
          class="nav-item" 
          :class="{ 'is-active': props.navigationPosition === 1 }"
          @click="redeemClicked"
          title="Reservas"
        >
          <div class="icon-circle">
            <img 
              :src="props.navigationPosition === 1 ? require('@/assets/images/canjear_icon_on.png') : require('@/assets/images/canjear_icon.png')"
              alt="Reservas" 
              class="header_icon"
            />
          </div>
          <span class="nav-label">Reservas</span>
        </button>

        <!-- Facturación (solo userType === 'main') -->
        <button 
          type="button"
          class="nav-item" 
          :class="{ 'is-active': props.navigationPosition === 2 }"
          @click="paymentsClicked"
          v-if="props.userType === 'main'"
          title="Facturación"
        >
          <div class="icon-circle">
            <img 
              :src="props.navigationPosition === 2 ? require('@/assets/images/payments_icon_on.png') : require('@/assets/images/payments_icon.png')"
              alt="Facturación" 
              class="header_icon"
            />
          </div>
          <span class="nav-label">Facturación</span>
        </button>

        <!-- Mis planes -->
        <button 
          type="button"
          class="nav-item" 
          :class="{ 'is-active': props.navigationPosition === 3 }"
          @click="plansClicked"
          title="Mis planes"
        >
          <div class="icon-circle">
            <img 
              :src="props.navigationPosition === 3 ? require('@/assets/images/plans_icon_on.png') : require('@/assets/images/plans_icon.png')"
              alt="Mis planes" 
              class="header_icon"
            />
          </div>
          <span class="nav-label">Mis planes</span>
        </button>

        <!-- Perfil (solo userType === 'main') -->
        <button 
          type="button"
          class="nav-item" 
          :class="{ 'is-active': props.navigationPosition === 4 }"
          @click="profileClicked"
          v-if="props.userType === 'main'"
          title="Perfil"
        >
          <div class="icon-circle">
            <img 
              :src="props.navigationPosition === 4 ? require('@/assets/images/profile_icon_on.png') : require('@/assets/images/profile_icon.png')"
              alt="Perfil" 
              class="header_icon"
            />
          </div>
          <span class="nav-label">Perfil</span>
        </button>

        <!-- Logout -->
        <button 
          type="button"
          class="nav-item logout-btn" 
          @click="logoutClicked"
          title="Cerrar sesión"
        >
          <div class="icon-circle">
            <img 
              src="@/assets/images/logout_icon.png" 
              alt="Cerrar sesión" 
              class="header_icon"
            />
          </div>
          <span class="nav-label">Salir</span>
        </button>
      </div>
    </div>
  </header>

  <TwoButtonPopup 
    :title="twoButtonTitle"
    :message="twoButtonMessage"
    :acceptButton="twoButtonAcceptButton"
    @acceptCallback="logoutConfirmed"
    :cancelButton="twoButtonCancelButton"
    @cancelCallback="twoButtonCancelCallback"
  />
</template>

<script setup>
import { ref, defineProps, onMounted, onBeforeUnmount } from "vue";
import { useRouter } from 'vue-router';
import TwoButtonPopup from './TwoButtonPopup.vue';

const props = defineProps({
  navigationPosition: Number, // 0 None, 1 Redeem, 2 Payments, 3 Profile, 4 Logout
  userType: String // "main" or "optional"
});

const router = useRouter();

const twoButtonTitle = ref("");
const twoButtonMessage = ref("");
const twoButtonAcceptButton = ref("");
const twoButtonCancelButton = ref("");
const loading = ref(false);

const logoutClicked = () => {
  twoButtonTitle.value = "Cerrar sesión";
  twoButtonMessage.value = "¿Estás seguro de que deseas cerrar sesión?";
  twoButtonAcceptButton.value = "Cerrar sesión";
  twoButtonCancelButton.value = "Cancelar";
};

const redeemClicked = () => {
  router.push('/redeem');
};

const paymentsClicked = () => {
  router.push('/payments');
};

const plansClicked = () => {
  router.push('/my-plans');
};

const profileClicked = () => {
  router.push('/profile');
};

const logoutConfirmed = async () => {
  twoButtonTitle.value = "";
  loading.value = true;
  try {
    const response = await fetch(process.env.VUE_APP_API_URL+"api/dashboard/auth/logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "vdas": process.env.VUE_APP_API_VDAS,
        "cp-token": process.env.VUE_APP_API_CP_TOKEN,
        "Authorization": "Bearer " + localStorage.getItem('token'),
      },
      body: JSON.stringify({
        "user_id": localStorage.getItem('user_id')
      }),
    });

    await response.json();

  } catch (exception) {
    // do nothing
  } finally {
    loading.value = false;
    localStorage.removeItem('user_id');
    localStorage.removeItem('token');
    router.push('/');
  }
};

const twoButtonCancelCallback = () => {
  twoButtonTitle.value = "";
  twoButtonMessage.value = "";
};

const isMobile = ref(window.innerWidth <= 768);

function handleResize() {
  isMobile.value = window.innerWidth <= 768;
}

onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

</script>

<style scoped>
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(47, 72, 88, 0.95);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  color: white;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 72px;
  z-index: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.25);
  padding: 0 1.5rem;
}

.header-content {
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
}

.logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity var(--transition-fast);
}

.logo:hover {
  opacity: 0.9;
}

.logo img {
  height: 38px;
  width: auto;
  object-fit: contain;
}

.header_icons_container {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.nav-item {
  background: transparent;
  border: none;
  border-radius: var(--radius-md);
  padding: 6px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  cursor: pointer;
  color: #CBD5E1;
  transition: all var(--transition-fast);
  position: relative;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.09);
  color: #FFFFFF;
  transform: translateY(-1px);
}

.nav-item.is-active {
  background: rgba(32, 205, 168, 0.16);
  color: var(--primary-color);
  font-weight: 600;
}

.nav-item.is-active::after {
  content: "";
  position: absolute;
  bottom: -4px;
  width: 18px;
  height: 2.5px;
  background-color: var(--primary-color);
  border-radius: 2px;
}

.icon-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
}

.header_icon {
  height: 22px;
  width: auto;
  transition: transform var(--transition-fast);
}

.nav-item:hover .header_icon {
  transform: scale(1.1);
}

.nav-label {
  font-size: 11px;
  letter-spacing: 0.02em;
}

.logout-btn {
  margin-left: 0.75rem;
  padding-left: 12px;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
}

.logout-btn:hover {
  background: rgba(248, 103, 103, 0.15);
  color: #FCA5A5;
}

@media screen and (max-width: 1160px) {
  .header {
    height: auto;
    padding: 10px 14px;
  }

  .header-content {
    flex-direction: column;
    gap: 10px;
  }

  .logo img {
    height: 100%;
    max-height: 32px;
    width: auto;
    max-width: 90%;
  }

  .header_icons_container {
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.2rem;
  }

  .nav-item {
    padding: 4px 7px;
  }

  .nav-label {
    display: none;
  }

  .logout-btn {
    margin-left: 0.25rem;
    border-left: none;
  }
}
</style>
  